<h1 id="title" class="title color-brand">{{ "AUTH.VALIDATION-TITLE" | translate }}</h1>
<p [ngClass]="{ 'sub-title': true, warning: statusCode && statusCode !== 0, success: statusCode && statusCode === 0 }">
    {{ message }}
</p>
<nb-alert *ngIf="alert.show" [status]="alert.type" role="alert">
    {{ alert.message }}
</nb-alert>

<ng-container *ngIf="validationCode">
    <form aria-labelledby="title" [formGroup]="form" #ngForm="ngForm" (ngSubmit)="validate()">
        <div class="form-control-group">
            <label class="label" for="input-validation">{{ "AUTH.VALIDATION-CODE" | translate }}</label>
            <!-- prettier-ignore -->
            <input
            nbInput
            fullWidth
            name="validation-code"
            id="input-validation"
            autofocus
            formControlName="validationCode"
            [status]="controls.validationCode.dirty ? (controls.validationCode.invalid ? 'danger' : 'success') : ''"
        />
            <ng-container *ngIf="controls.validationCode.invalid && controls.validationCode.touched">
                <p class="error-message" *ngIf="controls.validationCode.errors?.required">
                    {{ "MESSAGE.FIELD.MANDATORY" | translate }}
                </p>
                <p class="error-message" *ngIf="controls.validationCode.errors?.pattern">
                    {{ "MESSAGE.FIELD.INVALID-MAIL" | translate }}
                </p>
            </ng-container>
        </div>

        <button nbButton fullWidth status="primary" [disabled]="!ngForm.valid" [class.btn-pulse]="ngForm.submitted">
            Validar
        </button>

        <div class="d-flex flex-start mt-2">
            <a class="forgot-password caption-2" routerLink="../request-password">{{
                "AUTH.FORGOT-PASSWORD" | translate
            }}</a>
        </div>
    </form>
</ng-container>
